module.exports = __webpack_public_path__ + "static/img/app_1.49b0b5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ShopSelfPrinting/app_1.png
// module id = SrLU
// module chunks = 10